import React from 'react';
import { createStructuredSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationRootState } from '../../types';
import MobileAddShelf from '../Ribbon/CabinetRibbon/MobileAddShelf';
import { makeSelectDisplayFurniturePanel } from '../FurniturePanel/selectors';
import ShowFurnitureButton from '../Configurator/ShowFurnitureButton';
import { Shelf } from '../../lib/modelBuilder/entities/Shelf';
import { makeSelectShelvesSelected } from '../Configurator/selectors/selection';
import { makeSelectShelves } from '../Configurator/selectors/furniture';
import { FiTrash } from 'react-icons/fi';
import {
  removeShelfRequest,
  switchShelfPosition,
} from '../Configurator/actions/furniture';
import upShelf from 'assets/images/ribbons/shelvesRibbon/upShelf.svg';
import downShelf from 'assets/images/ribbons/shelvesRibbon/downShelf.svg';
import Img from '../../components/Img';

// import styled from 'styled-components';

interface StateProps {
  isMultiFurniture: boolean;
  shelvesSelected: Shelf[];
  shelvesCabinet: Shelf[];
}

const stateSelector = createStructuredSelector<
  ApplicationRootState,
  StateProps
>({
  isMultiFurniture: makeSelectDisplayFurniturePanel(),
  shelvesSelected: makeSelectShelvesSelected(),
  shelvesCabinet: makeSelectShelves(),
});

const IconBarCanvasMobile = () => {
  const { isMultiFurniture, shelvesSelected, shelvesCabinet } = useSelector(
    stateSelector,
  );
  const dispatch = useDispatch();

  let shelfLevel: number | undefined = undefined;
  if (shelvesCabinet.length > 1 && shelvesSelected.length === 1) {
    shelfLevel = shelvesSelected[0].level;
  }

  return (
    <div className="flex flex-col">
      <div className="mb-4 lg:mb-0">
        <ShowFurnitureButton />
      </div>

      {shelfLevel !== undefined && (
        <>
          <div className="flex justify-center mb-2 p-1 lg:mb-0">
            <button
              onClick={() => {
                if (shelfLevel !== undefined)
                  dispatch(switchShelfPosition(shelfLevel, 1));
              }}
            >
              <Img src={upShelf} alt="shelf up" className="h-8 w-8" />
            </button>
          </div>
          <div className="flex justify-center mb-2 p-1 lg:mb-0">
            <button
              onClick={() => {
                if (shelfLevel !== undefined)
                  dispatch(switchShelfPosition(shelfLevel, -1));
              }}
            >
              <Img src={downShelf} alt="shelf down" className="h-8 w-8" />
            </button>
          </div>
          <div className="flex justify-center mb-5 lg:mb-0">
            <button
              onClick={() => {
                if (shelfLevel !== undefined)
                  dispatch(removeShelfRequest(shelfLevel));
              }}
            >
              <FiTrash className="h-8 w-8 text-red-dark" />
            </button>
          </div>
        </>
      )}

      <div className="flex justify-center">
        {!isMultiFurniture && <MobileAddShelf shelfLevel={shelfLevel} />}
      </div>
    </div>
  );
};

export default IconBarCanvasMobile;
